// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-table td[data-v-322881b6],\n.el-table th[data-v-372de25b][data-v-322881b6] {\n  text-align: left !important;\n}\n[data-v-322881b6].el-table td {\n  text-align: left !important;\n}\n.bottom-box[data-v-322881b6] {\n  width: 100%;\n  height: 88px;\n  border-top: 1px solid #ebebfa;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  left: 0;\n  bottom: 0;\n}\n", ""]);
// Exports
module.exports = exports;
